import r from"./is-callable.js";import a from"./document-all.js";var e=r,o=a,n=o.all,t=o.IS_HTMLDDA?function(l){return typeof l=="object"?l!==null:e(l)||l===n}:function(l){return typeof l=="object"?l!==null:e(l)};export{t as default};
